import { z } from 'zod';
import { Plan } from './plan.js';

export const Order = z.object({
  txn: z.string(),
  client_id: z.string(),
  member_email: z.string().email(),
  purchase_date: z.string(),
  plan_details: Plan.partial().or(z.record(z.string(), z.unknown())),
  status: z.string(),
  quota_shared_by: z.array(z.string()).nullable().optional(),
});
export type Order = z.infer<typeof Order>;
